import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import { useMutation } from '@apollo/client'

import { MU_MANUFACTURER } from 'graphql/mutations'
import styles from '../../vehicle.module.scss'

const EditManufacturer = ({
  editable,
  setEditable,
  mft,
  setMessages,
  loading,
  update,
}) => {
  const [name, setName] = useState(mft.name)
  const [code, setCode] = useState(mft.code)
  const [detail, setDetail] = useState(mft.details)
  const [logo, setLogo] = useState(mft.logo)

  const [call] = useMutation(MU_MANUFACTURER)

  const saveData = () => {
    setEditable(false)
    loading(S => !S)
    let variables = { id: parseInt(mft.id) }
    if (name !== mft.name) {
      variables.name = name
    }
    if (code !== mft.code) {
      variables.code = code
    }
    if (detail !== mft.detail) {
      variables.detail = detail
    }
    if (logo !== mft.logo) {
      variables.logo = logo
    }
    call({
      variables,
    })
      .then(res => {
        update(S => !S)
      })
      .catch(err => console.error(err))
  }

  return (
    <div>
      {/* {!deleteUI ? ( */}
      <Dialog
        open={editable === mft.id}
        onClose={() => {
          setEditable()
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Edit Car Manufacturer {` - ${mft.id} - ${mft.name}`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>Edit current manufacturer</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            value={name}
            fullWidth
            onChange={e => setName(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            id="code"
            label="Code"
            type="text"
            value={code}
            fullWidth
            onChange={e => setCode(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            id="detail"
            label="Detail"
            type="text"
            value={detail}
            fullWidth
            onChange={e => setDetail(e.target.value)}
          />
          <Button fullWidth variant="contained" color="primary">
            Update Logo
            <input
              type="file"
              onChange={e => {
                setLogo(e.target.files.item(0))
              }}
              accept=".svg"
              className={styles.inputButton}
            ></input>
          </Button>
        </DialogContent>
        <div className={styles.actionWrapper}>
          <div className={styles.spacer} />
          <Button onClick={() => setEditable()} color="primary">
            Cancel
          </Button>
          <Button onClick={() => saveData()} color="primary">
            Save
          </Button>
        </div>
      </Dialog>
    </div>
  )
}

export default EditManufacturer
